document.addEventListener("DOMContentLoaded", function() {
    // Function to submit mobile filter form on change
    function submitMobileFilter() {
        if (document.getElementById("ecommerce-sidebar-filter-mobile")) {
            document.getElementById("ecommerce-sidebar-filter-mobile").submit();
        }
    }

    // Function to submit normal filter form on change
    function submitNormalFilter() {
        if (document.getElementById("ecommerce-sidebar-filter-normal")) {
            document.getElementById("ecommerce-sidebar-filter-normal").submit();
        }
    }

    // Event listener for change in mobile option
    document.addEventListener("change", function(event) {
        if (event.target.classList.contains("mobile-option")) {
            submitMobileFilter();
        }
    });

    // Event listener for change in normal filter
    document.addEventListener("change", function(event) {
        if (event.target.classList.contains("normal")) {
            submitNormalFilter();
        }
    });

    // Function to disable empty inputs and submit forms
    function submitWithDisabledEmptyInputs(formId) {
        var form = document.getElementById(formId);
        if (!form) return;
        
        var emptyInputs = form.querySelectorAll("input").filter(function(input) {
            return !input.value.trim();
        });
        
        emptyInputs.forEach(function(input) {
            input.disabled = true;
        });
        
        form.submit();
    }

    // Event listener for form submission for mobile filter
    if(document.getElementById("ecommerce-sidebar-filter-mobile")) {
        document.getElementById("ecommerce-sidebar-filter-mobile").addEventListener("submit", function(event) {
            event.preventDefault();
            submitWithDisabledEmptyInputs("ecommerce-sidebar-filter-mobile");
        });
    }
    
    // Event listener for form submission for normal filter
    if(document.getElementById("ecommerce-sidebar-filter-normal")) {
        document.getElementById("ecommerce-sidebar-filter-normal").addEventListener("submit", function(event) {
            event.preventDefault();
            submitWithDisabledEmptyInputs("ecommerce-sidebar-filter-normal");
        });
    }
});